<mat-slide-toggle
  class="rp-toggle"
  [labelPosition]="labelPosition()"
  [ngClass]="size()"
  disableRipple="true"
  [formControl]="ngControl.control"
  hideIcon
>
  {{ label() | translate }}
</mat-slide-toggle>
